import { Injectable } from "@angular/core";
import { InitBootstrapAction } from "./init-bootstrap.action";
import { InitPermissionsAction } from "./init-permissions.action";
import { InitUIMessageBrokerAction } from "./init-ui-message-broker.action";

@Injectable({
    providedIn: 'root'
  })
export class InitService {

    constructor(
        private initBootstrapAction: InitBootstrapAction,
        private initPermissionsAction: InitPermissionsAction,
        private initUIMessageBrokerAction: InitUIMessageBrokerAction) {

        }


    public init() : void {
        // Single BFF roundtrip — replaces what used to be the Configuration +
        // NavigationRules load (and the static GETs they wrapped).
        this.initBootstrapAction.load();
        this.initPermissionsAction.load();
        this.initUIMessageBrokerAction.load();
    }


}
